import React from "react";
import { ProgressBar } from "react-bootstrap";
import { formatAuslastung } from "../model/Ablauf";
import PropTypes from "prop-types";

const AlmigProgressBar = props => (
	<div className="ProgressContainer">
		<ProgressBar now={props.value * 100} />
		<center>{`${formatAuslastung(props.value)} %`}</center>
	</div>
);

AlmigProgressBar.propTypes = {
	value: PropTypes.number
};

export default AlmigProgressBar;
